exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".delegated-card-avatar{margin:0 6px;position:relative}.delegated-card-avatar avatar-app .avatar-container{width:50px;height:50px;line-height:50px}.delegated-card-avatar avatar-app .avatar-container.size-big .initials-container span{font-size:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardRow/homeDelegatedCard/delegatedCardAvatar/delegatedCardAvatar.scss
// module id = 1711
// module chunks = 0